module.exports = __webpack_public_path__ + "static/media/rank.d9d8f7be.png";